import { BelgeDto, ConteneurDto, ConteneurMobileDto, EtrangerDto, PersonneMoraleDto, PersonnePhysiqueDto, PlaquePersonnePhysiqueDto, SecondeResidenceDto, TypeDechetDto } from "src/api/models";

export interface VisiteursState {
  personneMorale: PersonneMoraleDto,
  personnePhysique: PersonnePhysiqueDto;
  belge: BelgeDto;
  etranger: EtrangerDto;
  secondeResidence: SecondeResidenceDto;
  typesDechets: TypeDechetDto[];
  plaquePersonnePhysique : PlaquePersonnePhysiqueDto;
  error: string;
}

export const VisiteursStateDefault = {
  personneMorale: null,
  personnePhysique: null,
  belge: null,
  etranger: null,
  secondeResidence: null,
  typesDechets: null,
  plaquePersonnePhysique: null,
  error: null

};

